export default __webpack_public_path__ + "static/media/StaticPage2.669a6e2f.txt";